/**
 * @author: dongjing
 * @file: description
 * @Date: 2020-01-08 16:58:27
 * @LastEditors: dongjing
 * @LastEditTime: 2020-02-03 18:08:23
 */
import React, { useState, useEffect } from 'react';
import './ItemTop.less';
import { Dropdown, Menu } from 'antd';
import { IconFont } from '../..';

export interface IItemTopProps {
  /** 置顶的id */
  id: number;
  /** 置顶标志 0 未置顶  1 已置顶 */
  stickyFlag: number;
  /** 置顶函数 */
  stickyFunc: (stickType: number, articleOrQuestionId: number) => void;
}
type Props = IItemTopProps;

export function ItemTop(props: Readonly<Props>) {
  const { id, stickyFlag, stickyFunc } = props;
  const [flag, setFlag] = useState(0);

  useEffect(() => {
    stickyFlag === 1 ? setFlag(0) : setFlag(1);
  }, [stickyFlag]);

  const handleSticky = () => {
    stickyFunc(flag, id);
  };
  const renderText = (type: number) => {
    if (type === 0) {
      return (
        <>
          <IconFont type="icon-zhiding" className="icon-top" style={{ marginRight: '4px' }} />
          <span>置顶</span>
        </>
      );
    } else {
      return (
        <>
          <IconFont type="icon-quxiaozhiding" className="icon-top" style={{ marginRight: '4px' }} />
          <span>取消置顶</span>
        </>
      );
    }
  };

  const menu = () => {
    return (
      <Menu
        onClick={() => {
          handleSticky();
        }}
      >
        <Menu.Item>{renderText(stickyFlag)}</Menu.Item>
      </Menu>
    );
  };
  return (
    <div
      className="k-common-item-top"
      onClick={(e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        e.preventDefault();
        e.stopPropagation();
      }}
    >
      <Dropdown overlay={menu} placement="bottomRight">
        <IconFont type="icon-gengduo" />
      </Dropdown>
    </div>
  );
}

export default ItemTop;
